/**
 * @generated SignedSource<<fed76f0d206bf682219b50142df7195e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutShippingStep_viewer$data = {
  readonly gdprDisplayInfo: {
    readonly isGdprApplicable: boolean | null;
  } | null;
  readonly id: string;
  readonly isMultiStageCheckoutOn: boolean | null;
  readonly restrictionsEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutEmailOnlyShippingForm_viewer" | "CheckoutGuestShippingForm_viewer" | "CheckoutShippingAddressListWrapper_viewer" | "CheckoutShippingForm_viewer">;
  readonly " $fragmentType": "CheckoutShippingStep_viewer";
};
export type CheckoutShippingStep_viewer$key = {
  readonly " $data"?: CheckoutShippingStep_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShippingStep_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutShippingStep_viewer",
  "selections": [
    {
      "alias": "restrictionsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "restrictedMaterials"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"restrictedMaterials\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingAddressListWrapper_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutEmailOnlyShippingForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutGuestShippingForm_viewer"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "gdprDisplayInfo",
      "kind": "LinkedField",
      "name": "gdprDisplayInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            }
          ],
          "kind": "ScalarField",
          "name": "isGdprApplicable",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "isMultiStageCheckoutOn",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiStageCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiStageCheckout\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "54eb0dc3998255c40d313e0a6d8f9dd6";

export default node;
